import React, { useState } from "react";
import { ArrowUpRight, ChevronsUp, HeartPulse, Workflow } from "lucide-react";
export default function CamundaAcceleters() {
  const [activeTab, setActiveTab] = useState(0);
  const accelerators = [
    {
      id: "01",
      title: "FHIR Connector",
      metric: "50% Faster time-to-market",
      icon: ChevronsUp,
      desc: "Streamline complex workflows and enhance operational efficiency with PEGA, a powerful low-code platform for building business-critical applications. With certified experts in PEGA, we enable seamless automation and optimized process management tailored to your unique requirements.",
    },
    {
      id: "02",
      title: "Agentic Industry Templates",
      icon: HeartPulse,
      metric: "FHIR R4 Heathcare-ready connectors",
      desc: "Unlock the potential of process automation with Camunda, an open-source platform for BPMN, CMMN, and DMN-based solutions. From designing workflows to monitoring and optimizing processes, we provide comprehensive support to improve your business agility and scalability.",
    },
    {
      id: "03",
      title: "Reduced Technical Debts",
      metric: "AntWorks Camunda Connector",
      icon: Workflow,
      desc: "Revolutionize your IT and enterprise service management with ServiceNow. We help businesses automate workflows, improve service delivery, and drive digital transformation with this robust and scalable platform.",
    },
  ];
  const Icon = accelerators[activeTab].icon;
  return (
    <section className="w-full bg-[#000036] lg:py-24 md:py-16 py-10 px-6 sm:px-8 lg:px-12 border-b border-slate-200/80 font-sans">
      <div className="max-w-7xl mx-auto space-y-16">
        <div className="text-left mb-20">
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-white">
            <span className="italic font-serif font-normal text-[#62d4f7]">
              Accelerators
            </span>{" "}
          </h2>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-12  gap-12 xl:gap-20 items-center">
          <div className="lg:col-span-6 divide-y divide-slate-200">
            {accelerators.map((item, idx) => {
              const isActive = activeTab === idx;
              return (
                <div
                  key={item.id}
                  onMouseEnter={() => setActiveTab(idx)}
                  className={`group py-8 cursor-pointer transition-colors duration-200 ${
                    isActive ? "opacity-100" : "opacity-60 hover:opacity-100"
                  }`}
                >
                  <div className="flex items-center justify-between">
                    <div className="flex items-center gap-5">
                      <h3 className="text-xl sm:text-2xl font-bold tracking-tight text-white">
                        {item.title}
                      </h3>
                    </div>
                    <ArrowUpRight
                      className={`w-5 h-5 transition-transform duration-200 ${
                        isActive
                          ? "text-white rotate-45"
                          : "text-slate-300 group-hover:text-slate-500"
                      }`}
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="group lg:sticky lg:top-24 rounded-xl lg:col-span-6 bg-white p-6 sm:p-8 text-slate-900 border border-black/10 shadow-[0_15px_40px_rgba(0,0,0,0.12)] transition-all duration-300 hover:shadow-2xl overflow-hidden">
            <div className="flex items-start justify-between mb-6">
              <div className="flex flex-col">
                <span className="font-serif text-5xl sm:text-6xl font-light tracking-tight text-[#000036] transition-all duration-300 group-hover:translate-x-1">
                  {accelerators[activeTab].id}
                </span>
              </div>
              <div className="h-14 w-14 rounded-2xl bg-slate-50 border border-black/5 shadow-sm flex items-center justify-center text-[#000036] transition-all duration-300 group-hover:bg-[#000036] group-hover:text-white group-hover:-rotate-6">
                <Icon size={28} strokeWidth={1.75} />
              </div>
            </div>
            <h3 className="text-2xl font-bold tracking-tight text-[#000036] leading-snug mb-4">
              {accelerators[activeTab].metric}
            </h3>
            <p className="text-base leading-relaxed text-slate-600 font-normal  mb-4">
              {accelerators[activeTab].desc}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
